import React, { useState, useEffect } from "react";
import { Container, Row, Col, Alert, Spinner, Modal } from "react-bootstrap";
import Navbar from "../components/Navbar";
import { activityPresets } from '../utils/activityLogger';
import { API_URL, buildFileUrl } from '../utils/apiConfig';
import '../styles/Beneficios.css'

const Beneficios = () => {
  const [beneficios, setBeneficios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

  useEffect(() => {
    cargarBeneficios();
  }, []);

  const cargarBeneficios = async () => {
    try {
      setLoading(true);
      
      // Obtener user y token desde localStorage
      const storedUser = localStorage.getItem('user');
      const user = storedUser ? JSON.parse(storedUser) : null;
      const token = localStorage.getItem('token');
      
      console.log('🔍 Debug Beneficios - Token:', token ? 'Presente ✓' : 'NO EXISTE ❌');
      console.log('🔍 Debug Beneficios - Usuario:', user);
      
      if (!token) {
        throw new Error('No se encontró token de autenticación. Por favor, inicia sesión nuevamente.');
      }
      
      // ✅ Consumir API con autenticación JWT
      const response = await fetch(`${API_URL}/api/beneficios`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'x-user-id': user?.Legajo || user?.CdEmpleado || localStorage.getItem('userId') || '1',
          'x-user-role': user?.IdRol || user?.tipoUsuario || localStorage.getItem('userRole') || '3'
        }
      });

      console.log('📡 Respuesta API:', response.status, response.statusText);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('❌ Error del servidor:', errorData);
        throw new Error(errorData.message || `Error del servidor: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Beneficios recibidos:', result);
      
      // Manejar respuesta (puede ser array directo o {success, data})
      const data = Array.isArray(result) ? result : (result.data || []);
      
      console.log('📦 Datos procesados:', data.length, 'beneficios');
      console.log('📋 Datos crudos del backend:', data);
      
      // Construir URLs completas desde el backend y agregar id y tipo
      const beneficiosConUrl = data.map((b, index) => {
        // Detectar tipo de archivo por extensión
        const extension = (b.archivo || b.nombre || '').toLowerCase().split('.').pop();
        const tipo = ['pdf'].includes(extension) ? 'pdf' : 'imagen';
        
        const urlFinal = buildFileUrl(b.url);
        
        console.log(`🖼️ Beneficio ${index + 1}:`, {
          nombreOriginal: b.nombre || b.archivo,
          urlBackend: b.url,
          urlFinal: urlFinal,
          tipo: tipo
        });
        
        return {
          id: index + 1,
          nombre: (b.archivo || b.nombre || 'Sin nombre').replace(/\.[^/.]+$/, ''), // Quitar extensión
          tipo: tipo,
          ruta: urlFinal // Usar helper para construir URL correctamente
        };
      });
      
      console.log('✅ Beneficios finales:', beneficiosConUrl);
      
      setBeneficios(beneficiosConUrl);
      setLoading(false);
    } catch (err) {
      console.error("❌ Error completo:", err);
      setError(err.message || "Error al cargar los beneficios");
      setLoading(false);
    }
  };

  useEffect(() => {
    const container = document.querySelector(".zoom-container");
    const image = document.querySelector(".zoom-image");

    if (!container || !image) return;

    let scale = 1;
    let posX = 0;
    let posY = 0;
    let isDragging = false;
    let startX, startY;

    // Zoom con la rueda del mouse
    const handleWheel = (e) => {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      scale = Math.min(Math.max(1, scale + delta), 4); // zoom 1x a 4x
      image.style.transform = `scale(${scale}) translate(${posX}px, ${posY}px)`;
    };

    // Inicia arrastre
    const handleMouseDown = (e) => {
      isDragging = true;
      startX = e.clientX - posX;
      startY = e.clientY - posY;
    };

    // Durante arrastre
    const handleMouseMove = (e) => {
      if (!isDragging) return;
      posX = e.clientX - startX;
      posY = e.clientY - startY;
      image.style.transform = `scale(${scale}) translate(${posX}px, ${posY}px)`;
    };

    // Soltar click
    const handleMouseUp = () => {
      isDragging = false;
    };

    container.addEventListener("wheel", handleWheel);
    container.addEventListener("mousedown", handleMouseDown);
    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseup", handleMouseUp);

    return () => {
      container.removeEventListener("wheel", handleWheel);
      container.removeEventListener("mousedown", handleMouseDown);
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseup", handleMouseUp);
    };
  }, [imagenSeleccionada]);





  if (loading) {
    return (
      <div className="init-container">
        <Navbar />
        <Container className="py-4 text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Cargando beneficios...</p>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="init-container">
        <Navbar />
        <Container className="py-4">
          <Alert variant="danger" className="text-center">
            <h5>⚠️ Error al cargar beneficios</h5>
            <p className="mb-0">{error}</p>
            {error.includes('token') && (
              <small className="d-block mt-2">
                Por favor, cierra sesión e inicia sesión nuevamente.
              </small>
            )}
          </Alert>
        </Container>
      </div>
    );
  }

  return (
    <div className="init-container">
      <Navbar />
      <Container className="py-4">
        <Row className="text-center mb-4">
          <h2>🎁 Beneficios para colaboradores</h2>
        </Row>

        {beneficios.length === 0 ? (
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="info" className="text-center shadow-sm p-4">
                No hay beneficios cargados por el momento.
              </Alert>
            </Col>
          </Row>
        ) : (
          <Row>
            {beneficios.map((beneficio) => (
              <Col key={beneficio.id} xs={12} md={6} lg={4} className="mb-4">
                {beneficio.tipo === 'pdf' ? (
                  // ✅ Mostrar PDFs como iframe o link
                  <div 
                    style={{
                      border: "2px solid #007bff",
                      borderRadius: "12px",
                      padding: "20px",
                      textAlign: "center",
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                    }}
                    onClick={() => {
                      activityPresets.view('beneficio', beneficio.id, { 
                        tipo: 'pdf', 
                        nombre: beneficio.nombre 
                      });
                      window.open(beneficio.ruta, '_blank');
                    }}
                  >
                    <i className="bi bi-file-pdf" style={{ fontSize: "48px", color: "#dc3545" }}></i>
                    <p className="mt-2 mb-0">{beneficio.nombre}</p>
                    <small className="text-muted">Click para abrir</small>
                  </div>
                ) : (
                  // ✅ Mostrar imágenes
                  <img
                    src={beneficio.ruta}
                    alt={`Beneficio ${beneficio.nombre}`}
                    style={{
                      width: "100%",
                      maxHeight: "90%",
                      objectFit: "cover",
                      borderRadius: "12px",
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    }}
                    onClick={() => {
                      activityPresets.view('beneficio', beneficio.id, { 
                        tipo: 'imagen', 
                        nombre: beneficio.nombre 
                      });
                      setImagenSeleccionada(beneficio.ruta);
                    }}
                    onError={(e) => {
                      console.error('❌ Error cargando imagen:', beneficio.ruta);
                      e.target.onerror = null; // Evitar loop infinito
                      e.target.style.display = 'none'; // Ocultar imagen rota
                    }}
                  />
                )}
              </Col>
            ))}
          </Row>
        )}
      </Container>

      {/* Modal para ver imagen grande - MEJORADO PARA MOBILE */}
      <Modal
        show={!!imagenSeleccionada}
        onHide={() => setImagenSeleccionada(null)}
        centered
        size="lg"
        dialogClassName="modal-imagen-grande"
      >
        <Modal.Body className="text-center p-0">
          {imagenSeleccionada && (
            <div className="zoom-container">
              <img
                src={imagenSeleccionada}
                alt="Beneficio en grande"
                className="zoom-image"
              />
            </div>
          )}
        </Modal.Body>

      </Modal>
    </div>
  );
};

export default Beneficios;